// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"c85a279c","229":"58cce487","354":"b00712aa","369":"afe6da80","481":"f31323fb","488":"49ec70ef","497":"abda4090","573":"0d552198","589":"6fff3343","663":"586714f9","721":"6f0a2702","878":"007e146b","924":"28c6fd1c"}[chunkId] + ".chunk.js";
};